import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { handleScroll } from './Navbar';

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
  {
    text: 'שובל כיוונה אותי אחרי תקופה של בלבול. היום אני לומדת תואר במדעי המחשב ועובדת במשרת סטודנט בתחום, הכל בזכות ההכוונה של שובל והייעוץ המדויק',
    name: 'מיכל כהן',
    title: 'Software Developer',
    color: 'from-pink-100 to-white',
    btn: 'bg-pink-500 hover:bg-pink-600',
    initials: 'מכ',
    avatar: 'bg-pink-300',
  },
  {
    text: 'אחרי התואר שובל עזרה לי להבין מה בדיוק מתאים לי, עשתה לי קורות חיים והכינה אותי לראיונות בצורה מדהימה.מצאתי עבודה מהר מאוד',
    name: 'רון ווקנין',
    title: 'Backend Developer',
    color: 'from-purple-100 to-white',
    btn: 'bg-purple-500 hover:bg-purple-600',
    initials: 'רו',
    avatar: 'bg-purple-300',
  },
  {
    text: 'שובל הייתה מקצועית מאוד ועזרה לי למצוא עבודה שמתאימה לי באמת',
    name: 'ליאור בן ישי',
    title: 'Product Manager',
    color: 'from-indigo-100 to-white',
    btn: 'bg-indigo-500 hover:bg-indigo-600',
    initials: 'לב',
    avatar: 'bg-indigo-300',
  },
];

const Advices = () => {
  const containerRef = useRef(null);

  useGSAP(() => {
    gsap.from('.testimonial-card', {
      y: 60,
      autoAlpha: 0,
      duration: 0.8,
      stagger: 0.15,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '.testimonials-grid',
        start: 'top 80%',
      },
    });
  }, { scope: containerRef });

  return (
    <section ref={containerRef} className="bg-gray-900 text-white py-24 px-4">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-bold mb-3 text-white">המלצות מלקוחות</h2>
        <p className="text-xl mb-14 text-gray-400">הפידבקים שלכם</p>
        <div className="testimonials-grid grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`testimonial-card bg-gradient-to-b ${t.color} p-8 rounded-2xl shadow-xl text-center`}
            >
              <div className="flex justify-center mb-5">
                <div className={`w-16 h-16 rounded-full ${t.avatar} flex items-center justify-center text-white font-bold text-xl`}>
                  {t.initials}
                </div>
              </div>
              <p className="text-lg mb-5 rtl text-gray-700 leading-relaxed">"{t.text}"</p>
              <p className="font-bold rtl text-gray-800 text-lg">{t.name}</p>
              <p className="text-sm text-gray-500 rtl mb-5">{t.title}</p>
              <button
                onClick={() => handleScroll('contact')}
                className={`px-5 py-2 rounded-full text-white text-sm font-medium ${t.btn} transition-colors duration-200`}
              >
                לפרטים
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advices;
